<template>
  <a href="https://clustrmaps.com/site/1c8bd" title="ClustrMaps"><img src="//www.clustrmaps.com/map_v2.png?d=WXQuB8n-IRNkBrDCD3AAOFaUpSmZRAEELV7Gd6spbw8&cl=ffffff"></a>
</template>

<script>
export default {
  name: 'FootMap'
}
</script>

<style scoped>

</style>
